( function () {
	'use strict';
	/* globals angular */

	function obsStatusFactory ( moment, apiService, observationsApi, Session ) {
		var credentials = Session.getCredentials();

		var collection = {
			'users'        : {},
			'locations'    : {},
			'districts'    : {},
			'locationsRaw' : {}
		};

		var allRawData = {};

		function iterateObjectKeys ( obj ) {
			function objectToArray ( key ) {
				return obj[ key ];
			}

			return Object.keys( obj ).map( objectToArray );
		}

		function reduceUsers ( curr ) {
			var innerKey = curr.PersonnelId;

			collection.users[ innerKey ] = collection.users[ innerKey ] || {
				'id'         : innerKey,
				'name'       : curr.FirstName + ' ' + curr.LastName,
				'locationId' : curr.ClientId,
				'districtId' : this.districtId
			};
		}

		function reduceLocation ( currKey ) {
			var curr = collection.locationsRaw[ currKey ];
			var dKey = curr.NCESDistrictID;
			var sKey = curr.ID;

			collection.districts[ dKey ] = collection.districts[ dKey ] || {
				'id'   : dKey,
				'name' : curr.District
			};

			collection.locations[ sKey ] = collection.locations[ sKey ] || {
				'id'         : sKey,
				'name'       : curr.SchoolName,
				'districtId' : dKey
			};

			( curr.users || [] ).forEach( reduceUsers.bind( { 'districtId' : dKey } ) );
		}

		function resetData () {
			collection.locations = {};
			collection.districts = {};
			collection.users     = {};
		}

		function convertData () {
			resetData();

			Object.keys( collection.locationsRaw ).forEach( reduceLocation );

			collection.districts = iterateObjectKeys( collection.districts );
			collection.locations = iterateObjectKeys( collection.locations );
			collection.users     = iterateObjectKeys( collection.users );
			allRawData           = angular.copy( collection );
		}

		function extractSchool ( col ) {
			( col || [] ).forEach( function ( curr ) {
				var key = curr.ID + '_' + curr.NCESDistrictID;

				collection.locationsRaw[ key ]       = collection.locationsRaw[ key ] || curr;
				collection.locationsRaw[ key ].users = collection.locationsRaw[ key ].users || curr.users;
			} );
		}

		function processLocation ( locations ) {
			extractSchool( locations );
			return locations;
		}

		function processHeirarchy  ( locations ) {
			locations.forEach( function ( location ) {
				extractSchool( location.Schools );
			} );
			return locations;
		}

		function fetchHeirarchy () {
			return apiService.users
				.query( {
					'userId' : credentials.userId,
					'rights' : 'view'
				} ).$promise;
		}

		function fetchReportTemplate () {
			return apiService.getTemplatesForReports.query().$promise;
		}

		function fetchObsLocations () {
			return apiService.getHierarchyForReports.query().$promise;
		}

		function fetchSubmittedObs () {
			return observationsApi.getObservationReport( false );
		}

		function fetchInprogressObs () {
			return observationsApi.getObservationReport( true );
		}

		function fetchInReviewObs () {
			return observationsApi.getObservationReport( false, true );
		}

		function getData ( arr, data, key ) {
			return arr.filter( function ( item ) {
				return ( item[ key ] || item.id ) === data.id;
			} )[ 0 ];
		}

		function insertData ( arr, data ) {
			if ( !getData( arr, data ) ) {
				arr.push( data );
			}
		}

		function reset () {
			var self = this;

			self.data = self.data || {};

			self.data.locationsRaw = {};
			self.data.locations    = {};
			self.data.districts    = {};
			self.data.users        = {};
		}

		return {
			'api' : {
				'fetchSubmittedObs'   : fetchSubmittedObs,
				'fetchInprogressObs'  : fetchInprogressObs,
				'fetchHeirarchy'      : fetchHeirarchy,
				'fetchObsLocations'   : fetchObsLocations,
				'fetchInReviewObs'    : fetchInReviewObs,
				'fetchReportTemplate' : fetchReportTemplate
			},

			'helpers' : {
				'objectToArray' : iterateObjectKeys
			},

			'processLocation'  : processLocation,
			'processHeirarchy' : processHeirarchy,
			'resetData'        : resetData,
			'convertData'      : convertData,
			'insertData'       : insertData,
			'getData'          : getData,

			'data'    : collection,
			'rawData' : allRawData,
			'reset'   : reset
		};
	}

	angular.module( 'app.report' )
		.factory( 'obsStatusFactory', obsStatusFactory );

	obsStatusFactory.$inject = [ 'moment', 'apiService', 'observationsApi', 'Session' ];
} )( );
